export default __webpack_public_path__ + "static/media/btn_mint_disable.c3bb335a.png";